const SPOKEN_DESTINATION_COMMAND = /^(?:(?:please|can you|could you)\s+)?(?:set the route to|set the destination to|change the route to|take (?:me|us) to|navigate (?:me|us) to|navigate to|go to|find me|find|i want to go to|i would like to go to)\s+/i;

export function normalizeDestinationVoiceTranscript(transcript) {
  const heard = String(transcript || "").trim().replace(/\s+/g, " ");
  if (!heard) return "";
  const withoutAssistantName = heard.replace(/^(?:(?:hey|okay|ok)\s+)?karen[,\s]+/i, "");
  return withoutAssistantName
    .replace(SPOKEN_DESTINATION_COMMAND, "")
    .replace(/[?.!,;:]+$/, "")
    .trim();
}
